import type { GetBillingAccountResponseSubscriptionDto } from 'app/API';

type TSubscriptionStatus = GetBillingAccountResponseSubscriptionDto['status'];

const EDITABLE_SUBSCRIPTION_STATUSES: TSubscriptionStatus[] = ['active', 'trialing', 'paused'];

export const isSubscriptionEditable = (status: TSubscriptionStatus): boolean =>
  EDITABLE_SUBSCRIPTION_STATUSES.includes(status);
